import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

export const LinkNotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <Result
        status="404"
        title="Link não encontrado"
        subTitle="Este link de compartilhamento não é mais válido ou não existe."
        extra={
          <Button type="primary" onClick={() => navigate('/')}>
            Ir para início
          </Button>
        }
      />
    </div>
  );
};

export default LinkNotFoundPage;
